/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum MailNodeContentType {
    Ticket = 2,
    Solution = 8,
}
